<!-- KeyMonitor -->
<script lang="ts" setup>
    import { onMounted, onBeforeUnmount, ref } from 'vue';

    const props = defineProps<{
        parentEle?: HTMLElement
    }>();

    const emit = defineEmits<{
        (e: "keydown", event: KeyboardEvent): void,
        (e: "keyup", event: KeyboardEvent): void,
      }>();

    const parentEleForListener = ref();

    onMounted(() => 
    {
        parentEleForListener.value = (props.parentEle ?? window);

        parentEleForListener.value.addEventListener("keydown", emitKeyDown);
        parentEleForListener.value.addEventListener("keyup", emitKeyUp);
    });

    onBeforeUnmount(() =>{
        parentEleForListener?.value.removeEventListener("keydown", emitKeyDown);
        parentEleForListener?.value.removeEventListener("keyup", emitKeyUp);
    });

    function emitKeyDown(event: KeyboardEvent)
    {
        if (event.isComposing) {
            return;
        }
        emit("keydown", event);
    }

    function emitKeyUp(event: KeyboardEvent)
    {
        if (event.isComposing) {
            return;
        }
        emit("keyup", event);
    }

</script>